// src/ChapterSelection.js
// import React, { useState } from 'react';

const ChapterSelection = ({
  selectedSubject,
  selectedClass,
  selectedChapter,
  onChapterSelected,
}) => {
  const handleChapterChange = (event) => {
    const newSelectedChapter = event.target.value;
    onChapterSelected(newSelectedChapter); // Notify the parent component of the selected chapter
  };

  // You can replace this sample chapter data with your actual chapter data
  const chapterData = {
    Maths: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],

      // Add chapters for other classes here
    },
    science: {
      // class
      1: [1, 2, 3],
      // class
      2: [1, 2, 3],

      // Add chapters for other classes here
    },
    Evs: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    },
    English: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],

    },Moral: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],

    },
    Grammar: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],

    },
    Hindi: {
      1: [1, 2, 3, 4, 5, 6, 7, 8],
      2: [1, 2, 3, 4, 5, 6],
      3: [1, 2, 3, 4, 5, 6],
      4: [1, 2, 3, 4, 5, 6],
      5: [1, 2, 3, 4, 5, 6],
      6: [1, 2, 3, 4, 5, 6],
      7: [1, 2, 3, 4, 5, 6],
      8: [1, 2, 3, 4, 5, 6],
    },
    Science: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    Sst: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      3: [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    },
    Computer: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7],
      2: [1, 2, 3, 4, 5, 6, 7],
      3: [1, 2, 3, 4, 5, 6, 7, 8],
      4: [1, 2, 3, 4, 5, 6, 7],
      5: [1, 2, 3, 4, 5, 6, 7, 8],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    },
    Gk:{
      1: [1, 2, 3, 4, 5, 6, 7],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      4: [1, 2, 3, 4, 5, 6, 7, 8],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      8: [1, 2, 3, 4, 5, 6],
    },
    Vyakaran: {
      // class
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      // class
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      7: [1, 2, 3, 4, 5, 6],
      8: [1, 2, 3, 4, 5, 6],

      // Add chapters for other classes here
    },
  };

  const chapters = chapterData[selectedSubject]?.[selectedClass] || [];

  return (
    <div className="p-4 border rounded-md shadow-md">
      <h2 className="text-lg font-semibold mb-2">
        Select a Chapter for {selectedSubject}, {selectedClass}:
      </h2>
      <select
        className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:border-blue-500"
        onChange={handleChapterChange}
        value={selectedChapter}
      >
        <option value="">-- Select a Chapter --</option>
        {chapters.map((chapter) => (
          <option key={chapter} value={chapter}>
            {chapter}
          </option>
        ))}
      </select>
      <p className="mt-2">Selected Chapter: {selectedChapter}</p>
    </div>
  );
};

export default ChapterSelection;
